import { useMutation, useQueryClient } from "@tanstack/react-query";

import { uploadAttendanceAttachment } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { AttendanceAttachment } from "../types";
import { toAttendanceAttachment } from "../utils/map";
import { invalidateAttendance } from "./invalidate-attendance";

export interface UploadAttachmentInput {
	workerId: string;
	date: string;
	file: File;
}

export function useUploadAttachment() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: async (
			input: UploadAttachmentInput,
		): Promise<AttendanceAttachment> =>
			toAttendanceAttachment(
				await uploadAttendanceAttachment(
					activeCanteiroId as string,
					input.workerId,
					input.date,
					input.file,
				),
			),
		onSuccess: () => invalidateAttendance(queryClient),
	});
}
